var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25H14C14.4142 3.25 14.75 3.58579 14.75 4C14.75 4.41421 14.4142 4.75 14 4.75H2C1.58579 4.75 1.25 4.41421 1.25 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66671 2.08301C6.512 2.08301 6.36362 2.14447 6.25423 2.25386C6.14483 2.36326 6.08337 2.51163 6.08337 2.66634V3.24967H9.91671V2.66634C9.91671 2.51163 9.85525 2.36326 9.74585 2.25386C9.63646 2.14447 9.48808 2.08301 9.33337 2.08301H6.66671ZM11.4167 3.24967V2.66634C11.4167 2.11381 11.1972 1.5839 10.8065 1.1932C10.4158 0.802501 9.88591 0.583008 9.33337 0.583008H6.66671C6.11417 0.583008 5.58427 0.802501 5.19357 1.1932C4.80287 1.5839 4.58337 2.11381 4.58337 2.66634V3.24967H3.33337C2.91916 3.24967 2.58337 3.58546 2.58337 3.99967V13.333C2.58337 13.8855 2.80287 14.4154 3.19357 14.8061C3.58427 15.1968 4.11417 15.4163 4.66671 15.4163H11.3334C11.8859 15.4163 12.4158 15.1968 12.8065 14.8061C13.1972 14.4154 13.4167 13.8855 13.4167 13.333V3.99967C13.4167 3.58546 13.0809 3.24967 12.6667 3.24967H11.4167ZM4.08337 4.74967V13.333C4.08337 13.4877 4.14483 13.6361 4.25423 13.7455C4.36362 13.8549 4.512 13.9163 4.66671 13.9163H11.3334C11.4881 13.9163 11.6365 13.8549 11.7459 13.7455C11.8552 13.6361 11.9167 13.4877 11.9167 13.333V4.74967H4.08337Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 6.58301C9.74747 6.58301 10.0833 6.91879 10.0833 7.33301V11.333C10.0833 11.7472 9.74747 12.083 9.33325 12.083C8.91904 12.083 8.58325 11.7472 8.58325 11.333V7.33301C8.58325 6.91879 8.91904 6.58301 9.33325 6.58301Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 6.58301C7.08096 6.58301 7.41675 6.91879 7.41675 7.33301V11.333C7.41675 11.7472 7.08096 12.083 6.66675 12.083C6.25253 12.083 5.91675 11.7472 5.91675 11.333V7.33301C5.91675 6.91879 6.25253 6.58301 6.66675 6.58301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bef48a583a411e9afa05c4414fce15c1.svg";
export { ForwardRef as ReactComponent };